import MarkdownRenderer from "../components/MarkdownRenderer";

const Community = () => {
  return (
    <div>
      <MarkdownRenderer filePath="/posts/Community.md" />
    </div>
  );
};

export default Community;
